import { render, staticRenderFns } from "./PaginaPagamentiContratti.vue?vue&type=template&id=17a96c64"
import script from "./PaginaPagamentiContratti.vue?vue&type=script&lang=js"
export * from "./PaginaPagamentiContratti.vue?vue&type=script&lang=js"
import style0 from "./PaginaPagamentiContratti.vue?vue&type=style&index=0&id=17a96c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports